import { MaskModel } from "./model.interface";

const digit = /\d/;
const letterC = /[cC]/i;
const letterT = /[tT]/i;
const letterD = /[dD]/i;
const letterZ = /[zZ]/i;
const digitOrSlash = /[\d\/]/;

export const technicCert: MaskModel = {
    mask: (rawValue: string) => {
        const prefix = [letterC, letterT, ' '];
        const prefixLength = 3;

        const slashIndex = rawValue.indexOf('/');

        if (slashIndex !== -1) {
            const digitsCount = Math.min(3, Math.max(0, slashIndex - prefixLength));

            const mask = [...prefix];
            for (let i = 0; i < digitsCount; i++) {
                mask.push(digit);
            }
            mask.push('/');
            mask.push(digit, digit, digit, digit);
            return mask;
        }

        const currentLength = rawValue.length;
        const digitsEntered = Math.max(0, currentLength - prefixLength);

        if (digitsEntered >= 3) {
            return [...prefix, digit, digit, digit, '/'];
        } else {
            const mask = [...prefix];
            for (let i = 0; i < digitsEntered; i++) {
                mask.push(digit);
            }
            mask.push(digitOrSlash);
            return mask;
        }
    },
    guide: false,
    keepCharPositions: false,
    showMask: false
};

export const workshopCert: MaskModel = {
    mask: (rawValue: string) => {
        let prefix = [];

        if (rawValue && letterZ.test(rawValue[0])) {
            prefix = [letterZ, letterD, letterT, ' '];
        } else {
            prefix = [letterD, letterT, ' '];
        }

        const prefixLength = prefix.length;
        const slashIndex = rawValue.indexOf('/');

        if (slashIndex !== -1) {
            const digitsCount = Math.min(3, Math.max(0, slashIndex - prefixLength));

            const mask = [...prefix];
            for (let i = 0; i < digitsCount; i++) {
                mask.push(digit);
            }
            mask.push('/');
            mask.push(digit, digit, digit, digit);
            return mask;
        }

        const currentLength = rawValue.length;
        const digitsEntered = Math.max(0, currentLength - prefixLength);

        if (digitsEntered >= 3) {
            return [...prefix, digit, digit, digit, '/'];
        } else {
            const mask = [...prefix];
            for (let i = 0; i < digitsEntered; i++) {
                mask.push(digit);
            }
            mask.push(digitOrSlash);
            return mask;
        }
    },
    guide: false,
    keepCharPositions: false,
    showMask: false
};